import React from 'react';
import type { EmThread } from '../../email/types';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';

export interface EmailTopBarActionsProps {
  onCompose?: () => void;
  onBell?: () => void;
  threads?: EmThread[];
  /** Org-wide email autopilot (spec §5). Undefined hides the control. */
  autopilotOn?: boolean;
  onToggleAutopilot?: () => void;
  autopilotBusy?: boolean;
}

/** Email header actions — Autopilot (when wired) + Compose. */
export function EmailTopBarActions({
  onCompose,
  autopilotOn,
  onToggleAutopilot,
  autopilotBusy = false,
}: EmailTopBarActionsProps) {
  return (
    <div className="flex shrink-0 items-center justify-end gap-2">
      {autopilotOn !== undefined ? (
        <button
          type="button"
          onClick={onToggleAutopilot}
          disabled={autopilotBusy}
          aria-pressed={autopilotOn}
          title={
            autopilotOn
              ? 'Email autopilot is ON for the whole inbox — Elva auto-sends replies above the confidence bar. Click to turn off.'
              : 'Email autopilot is OFF — every reply is held as a draft for review. Click to turn on.'
          }
          className="inline-flex h-8 items-center gap-2 rounded-[var(--r-pill)] border px-[11px] text-[11.5px] font-semibold"
          style={{
            cursor: autopilotBusy ? 'default' : 'pointer',
            opacity: autopilotBusy ? 0.6 : 1,
            color: autopilotOn ? 'var(--ai-3)' : 'var(--ink-3)',
            background: autopilotOn ? 'var(--ai-tint)' : 'var(--cream-1)',
            borderColor: autopilotOn
              ? 'color-mix(in srgb, var(--ai-3) 40%, transparent)'
              : 'var(--cream-2)',
          }}
        >
          <Icon kind="sparkle" size={13} />
          Autopilot
          <span
            aria-hidden
            style={{
              width: 26,
              height: 15,
              borderRadius: 999,
              padding: 2,
              display: 'inline-flex',
              justifyContent: autopilotOn ? 'flex-end' : 'flex-start',
              background: autopilotOn ? 'var(--ai-3)' : 'var(--cream-3, var(--ink-4))',
              transition: 'background 120ms',
            }}
          >
            <span style={{ width: 11, height: 11, borderRadius: 999, background: '#fff' }} />
          </span>
        </button>
      ) : null}
      <Button variant="primary" size="sm" iconLeft="plus" onClick={onCompose}>
        Compose
      </Button>
    </div>
  );
}
